import { component } from 'picoapp';

export default component((node) => {
  const currentTitle = node.querySelector<HTMLElement>('[data-current-title]');
  let initialTitle = currentTitle.textContent;

  const labels = node.querySelectorAll('label');

  labels.forEach((label) => {
    const input = node.querySelector<HTMLInputElement>(`#${label.htmlFor}`);

    label.addEventListener('click', () => {
      initialTitle = input.value;
    });

    label.addEventListener('mouseenter', () => {
      currentTitle.textContent = input.value;
    });

    label.addEventListener('mouseleave', () => {
      currentTitle.textContent = initialTitle;
    });
  });
});
